import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export const FaqSection = ({
  items,
  title = "Domande frequenti sulla consulenza aziendale",
  eyebrow = "Domande frequenti",
  showAllLink = true,
  compact = false,
}) => (
  <section
    className={compact ? "py-16 sm:py-20 border-t border-[#141414]" : "py-16 sm:py-32 border-t border-[#141414]"}
    data-testid="faq-section"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <div className={compact ? "grid grid-cols-1 lg:grid-cols-12 gap-10" : ""}>
        <div className={compact ? "lg:col-span-4" : ""}>
          <p className="eyebrow mb-5">{eyebrow}</p>
          <h2
            className={
              compact
                ? "text-2xl sm:text-3xl font-bold text-white leading-tight"
                : "text-3xl sm:text-4xl lg:text-5xl font-bold text-white max-w-3xl leading-tight"
            }
            style={{ fontFamily: "'Outfit', sans-serif", letterSpacing: "-0.025em" }}
          >
            {title}
          </h2>
          {compact && showAllLink && (
            <Link
              to="/blog"
              className="mt-6 tap-target gap-2 text-sm text-[#FACC15] hover:gap-3 transition-all"
              data-testid="faq-all-link"
            >
              Vedi tutte le risposte dell'esperto
              <ArrowRight size={15} />
            </Link>
          )}
        </div>

        <div className={compact ? "lg:col-span-8 space-y-px" : "mt-12 space-y-px"}>
          {items.map((f) => (
            <details
              key={f.slug}
              className="group border border-[#1a1a1a] bg-[#0c0c0c] open:border-[#FACC15]/40 transition-colors"
              data-testid={`faq-item-${f.slug}`}
            >
              <summary className={`cursor-pointer list-none flex items-start justify-between gap-4 ${compact ? "p-5" : "p-6"}`}>
                <h3
                  className={`text-white font-semibold pr-4 ${compact ? "text-base" : "text-lg"}`}
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {f.q}
                </h3>
                <span className="text-[#FACC15] text-2xl leading-none transition-transform group-open:rotate-45">
                  +
                </span>
              </summary>
              <div className={compact ? "px-5 pb-6" : "px-6 pb-7"}>
                <p className="text-white/75 text-base leading-relaxed max-w-3xl">{f.a}</p>
                <Link
                  to={`/esperto-risponde/${f.slug}`}
                  className="mt-3 tap-target gap-2 text-sm text-[#FACC15] hover:gap-3 transition-all"
                  data-testid={`faq-detail-link-${f.slug}`}
                >
                  Approfondisci
                  <ArrowRight size={15} />
                </Link>
              </div>
            </details>
          ))}
        </div>
      </div>

      {!compact && showAllLink && (
        <Link
          to="/blog"
          className="mt-10 btn-outline-yellow inline-flex items-center gap-2"
          data-testid="faq-all-link"
        >
          Vedi tutte le risposte dell'esperto
          <ArrowRight size={16} />
        </Link>
      )}
    </div>
  </section>
);

export default FaqSection;
